import { FunctionComponent, memo } from "react";
import { Box } from "../../box";
import { Text } from "../../text";
import { Timeline } from "../../timeline";
import { IProps } from "./changelog-entry.types";

/**
 * A single changelog timeline item: a coloured icon bullet, a bold title, optional body
 * content, and a dimmed meta line. The meta line is rendered after the content (rather than
 * via `Timeline.Item`'s `footer`, which renders before children) so it always sits last.
 * @param props.entry - The entry's icon, colour, title, meta and content.
 */
const ChangelogEntryComponent: FunctionComponent<IProps> = ({ entry }) => (
    <Timeline.Item title={entry.title} icon={entry.icon} color={entry.color ?? "primary"}>
        {entry.content && (
            <Box mt="xs" w="100%">
                {entry.content}
            </Box>
        )}
        {entry.meta && (
            <Text dimmed size="xs" mt="sm">
                {entry.meta}
            </Text>
        )}
    </Timeline.Item>
);

const ChangelogEntry = memo(ChangelogEntryComponent);

export { ChangelogEntry };
